import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Once you have `}<a parentName="p" {...{
        "href": "downloading-and-installing-packages"
      }}>{`installed a package`}</a>{` in `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`, you can use it in your code.`}</p>
    <h2>{`Using unscoped packages in your projects`}</h2>
    <h3>{`Node.js module`}</h3>
    <p>{`If you are creating a Node.js module, you can use a package in your module by passing it as an argument to the `}<inlineCode parentName="p">{`require`}</inlineCode>{` function.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var lodash = require('lodash');

var output = lodash.without([1, 2, 3], 1);
console.log(output);
`}</code></pre>
    <h3>{`package.json file`}</h3>
    <p>{`In `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, list the package under dependencies. You can optionally include a `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic version`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "dependencies": {
    "@package_name": "^1.0.0"
  }
}
`}</code></pre>
    <h2>{`Using scoped packages in your projects`}</h2>
    <p>{`To use a scoped package, simply include the scope wherever you use the package name.`}</p>
    <h3>{`Node.js module`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var projectName = require("@scope/package-name")
`}</code></pre>
    <h3>{`package.json file`}</h3>
    <p>{`In `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "dependencies": {
    "@scope/package_name": "^1.0.0"
  }
}
`}</code></pre>
    <h2>{`Resolving "Cannot find module" errors`}</h2>
    <p>{`If you have not properly installed a package, you will receive an error when you try to use it in your code. For example, if you reference the `}<inlineCode parentName="p">{`lodash`}</inlineCode>{` package without installing it, you would see the following error:`}</p>
    <pre><code parentName="pre" {...{}}>{`module.js:340
    throw err;
          ^
Error: Cannot find module 'lodash'
`}</code></pre>
    <ul>
      <li parentName="ul">{`For scoped packages, run `}<inlineCode parentName="li">{`npm install <@scope/package_name>`}</inlineCode></li>
      <li parentName="ul">{`For unscoped packages, run `}<inlineCode parentName="li">{`npm install <package_name>`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      